import { CalendarDate } from '@internationalized/date';
import {
  enumSalesLoadLineItemPhase,
  enumUnit,
  enumWeightDisplayUnit,
  LoadLineItemInput,
  SalesItemLineType,
} from '@rematter/frontend-lib-api-client';
import Big from 'big.js';

import {
  BrokeredLoadFormLineItem,
  BrokeredLoadFormState,
  enumBrokeredLoadWeightType,
} from '../types/brokeredLoad';

export const initialBrokeredLoadState = (): BrokeredLoadFormState => ({
  supplierId: undefined,
  brokeredOrderId: undefined,
  salesOrderId: undefined,
  bookingId: undefined,
  facilityId: undefined,
  expectedShipDate: undefined,
  status: undefined,
  weightDisplayUnit: enumWeightDisplayUnit.PriceUnit,
  deliveryNumber: undefined,
  lineItems: [],
});

const transformBrokeredLoadLineItem = (
  item: BrokeredLoadFormLineItem,
): LoadLineItemInput => ({
  type: (item.type as SalesItemLineType) ?? 'Raw',
  itemId: item.itemId || undefined,
  purchaseOrderId: item.purchaseOrderId || undefined,
  pricingUnit: item.pricingUnit || enumUnit.Pounds,
  phase: enumSalesLoadLineItemPhase.Requested,
  unitPrice: item.unitPrice
    ? {
        amount: item.unitPrice.amount,
        currencyCode: item.unitPrice.currencyCode,
      }
    : undefined,
  estimatedPrice: item.estimatedPrice
    ? {
        amount: item.estimatedPrice.amount,
        currencyCode: item.estimatedPrice.currencyCode,
      }
    : undefined,
  weights: {
    [enumBrokeredLoadWeightType.Gross]: {
      value: new Big(
        item.weights?.[enumBrokeredLoadWeightType.Gross]?.value || 0,
      ).toNumber(),
      unit:
        item.weights?.[enumBrokeredLoadWeightType.Gross]?.unit ||
        enumUnit.Pounds,
    },
    [enumBrokeredLoadWeightType.Tare]: {
      value: new Big(
        item.weights?.[enumBrokeredLoadWeightType.Tare]?.value || 0,
      ).toNumber(),
      unit:
        item.weights?.[enumBrokeredLoadWeightType.Tare]?.unit ||
        enumUnit.Pounds,
    },
    [enumBrokeredLoadWeightType.Net]: {
      value: new Big(
        item.weights?.[enumBrokeredLoadWeightType.Net]?.value || 0,
      ).toNumber(),
      unit:
        item.weights?.[enumBrokeredLoadWeightType.Net]?.unit || enumUnit.Pounds,
    },
  },
});

export const transformBrokeredLoadCreateInput = (
  formData: BrokeredLoadFormState,
) => ({
  expectedShipDate: formData.expectedShipDate as CalendarDate,
  salesOrderId: formData.salesOrderId ?? undefined,
  bookingId: formData.bookingId ?? undefined,
  supplierId: formData.supplierId as string,
  brokeredOrderId: formData.brokeredOrderId ?? undefined,
  facilityId: formData.facilityId as string,
  weightDisplayUnit:
    formData.weightDisplayUnit ?? enumWeightDisplayUnit.PriceUnit,
  deliveryNumber: formData.deliveryNumber ?? undefined,
  documentNumber: formData.documentNumber ?? undefined,
  lineItems: formData.lineItems.map((item) =>
    transformBrokeredLoadLineItem(item),
  ),
});
